/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  Form,
  Input,
  InputNumber,
  Row,
  Col,
  DatePicker,
  notification,
  Select,
  Divider,
  Space,
  Typography,
  Button,
} from 'antd';
import { PlusOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { X } from 'lucide-react';
import isEmpty from 'lodash/isEmpty';
import { addClient } from '../redux/actions/clientAction';
import { NDT_PIPELINE_TYPE_OPTIONS } from '../constants/ndtPipelineTypeOptions';
import moment from 'moment';
import { getUsers, getAccess } from '../services/userManagement';
import { createDefaultTeamMember } from '../utils/teamMemberConfig';
import { Button as CrceButton } from '@crc-evans/ui-components';
import { getPopupContainerBody } from './ShippingManagement/shipmentFieldOptions';
import './DSR/DownTimeModal.css';
import '../pages/dashboard/DashboardPage.css';

const { Option } = Select;
const { Text } = Typography;

const CreateProject = (props) => {
  const { projectForm, onSaveProject, clientList, onAddClient } = props;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [projectId, setProjectId] = useState(undefined);
  const [projectName, setProjectName] = useState('');
  const [client, setClient] = useState('');
  const [manager, setManager] = useState('');
  // handle start date and end date entry. start < end
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [contractId, setContractId] = useState(undefined);
  const [pihRefId, setPihRefId] = useState(undefined);
  const [contractor, setContractor] = useState('');
  const [location, setLocation] = useState('');
  const [projectType, setProjectType] = useState(undefined);
  const [projectNdtType, setProjectNdtType] = useState(undefined);
  const [newClient, setNewClient] = useState('');
  const [finalClient, setFinalClient] = useState('');
  const [newFinalClient, setNewFinalClient] = useState('');
  const [dayShiftHour, setDayShiftHour] = useState('');
  const [nightShiftHour, setNightShiftHour] = useState('');

  const showModal = () => {
    setIsModalVisible(true);
  };

  const getTeamMember = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    let teamMember = {};
    if (user) {
      var firstName = user['custom:first_name'] ? user['custom:first_name'] : '';
      var lastName = user['custom:last_name'] ? user['custom:last_name'] : '';
      var email = user['email'] ? user['email'] : '';
      let userRes = await getUsers('', email);
      if (userRes) {
        const response = await getAccess(userRes.users[0].Username);
        let isUserAdmin =
          response.map((x) => x.GroupName).includes('admin') ||
          response.map((x) => x.GroupName).includes('super-admin');
        if (!isUserAdmin) {
          teamMember = createDefaultTeamMember({
            cognitoUserId: userRes.users[0].Username,
            firstName,
            lastName,
            email,
          });
        } else {
          teamMember = null;
        }
      }
    }
    return teamMember;
  };

  const handleOk = async () => {
    try {
      let teamMember = await getTeamMember();
      projectForm.validateFields().then((data) => {
        if (
          (data.projectName !== undefined || '') &&
          (data.projectId !== undefined || '') &&
          (data.clientName !== undefined || '') &&
          (data.manager !== undefined || '') &&
          data.startDate &&
          (data.contractId !== undefined || '') &&
          (data.pihRefId !== undefined || '') &&
          (data.contractor !== undefined || '') &&
          (data.location !== undefined || '') &&
          (data.projectType !== undefined && data.projectType !== '')
        ) {
          var fromDate = moment(data.startDate).format('YYYY-MM-DD');
          var toDate = moment(data.endDate).format('YYYY-MM-DD');
          if (fromDate > toDate) {
            notification.warn({
              message: 'Start date should be previous than End date',
            });
          } else {
            data['teamMember'] = teamMember;
            data['projectType'] = projectType ?? data.projectType ?? '';
            data['finalClient'] = finalClient;
            data['ndtType'] = projectNdtType ?? '';
            const pt = projectType ?? data.projectType ?? '';
            data['ndtRejectMaxPercent'] =
              pt === 'Welding' || pt === 'Both'
                ? projectForm.getFieldValue('ndtRejectMaxPercent')
                : undefined;
            onSaveProject(data, client);
            setIsModalVisible(false);
            projectForm.resetFields();
            setClient('');
            setFinalClient('');
            setProjectType(undefined);
            setProjectNdtType(undefined);
            setStartDate(null);
            setEndDate(null);
          }
        } else {
          notification.warning({
            message: 'Fill all the required fields!',
          });
        }
      });
    } catch (error) {
      // console.log("error", error)
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    projectForm.resetFields();
    setClient('');
    setFinalClient('');
    setProjectType(undefined);
    setProjectNdtType(undefined);
    setStartDate(null);
    setEndDate(null);
  };

  const onChange = (value) => {
    if (clientList.length > 0) {
      const clientData = clientList.find((u) => u.name === value);
      setClient(clientData);
    }
  };

  const onSearch = (value, id) => {
    console.log('search:', value, id);
  };

  const onAddNewClient = (event) => {
    setNewClient(event.target.value);
  };

  const addItem = (e) => {
    e.preventDefault();
    if (!isEmpty(newClient) && !isEmpty(newClient.trim())) {
      const clientData = {
        name: newClient,
      };
      onAddClient(clientData);
      setNewClient('');
    }
  };

  const removeItem = (e) => {
    e.preventDefault();
    setNewClient('');
  };

  const onChangeFinalClient = (value) => {
    setFinalClient(value);
  };

  const onAddNewFinalClient = (event) => {
    setNewFinalClient(event.target.value);
  };

  const addFinalClientItem = (e) => {
    e.preventDefault();
    if (!isEmpty(newFinalClient) && !isEmpty(newFinalClient.trim())) {
      onAddClient({ name: newFinalClient });
      setNewFinalClient('');
    }
  };

  const removeFinalClientItem = (e) => {
    e.preventDefault();
    setNewFinalClient('');
  };
  //Dashboard create project  access control for normal user and web-page-without-create-project

  const [isWriteAccess, setIsWriteAccess] = useState(false);

  useEffect(() => {
    const storedUserGroup = localStorage.getItem('UserGroup');
    let parsedUserGroup;
    try {
      parsedUserGroup = JSON.parse(storedUserGroup);
    } catch (error) {
      parsedUserGroup = storedUserGroup ? storedUserGroup.split(',') : [];
    }
    if (
      parsedUserGroup?.includes('admin') ||
      parsedUserGroup?.includes('super-admin') ||
      parsedUserGroup?.includes('web-page')
    ) {
      setIsWriteAccess(true);
    } else if (
      parsedUserGroup?.includes('web-page-without-create-project') ||
      parsedUserGroup?.includes('super-admin') ||
      parsedUserGroup?.includes('admin')
    ) {
      setIsWriteAccess(false);
    }
  }, []);

  return (
    <>
      {/* <div onClick={showModal} className="new-project-team">
        <Text onClick={showModal} className="ps-3 add-new-team" >
          <span className="icon-22">
            <svg>
              <use xlinkHref="#add" />
            </svg>
          </span>
          Create New Project
        </Text>
      </div> */}
      <Button
        type="primary"
        icon={<PlusOutlined style={{ color: isWriteAccess ? '' : 'gray' }} />}
        onClick={isWriteAccess ? showModal : undefined}
        disabled={!isWriteAccess}
        style={{
          height: '54px',
          borderRadius: '10px',
          fontWeight: 'bold',
          opacity: isWriteAccess ? 1 : 0.65,
        }}
      >
        Add Project
      </Button>

      <Modal
        width="min(92vw, 900px)"
        className="modern-create-project-modal modern-dsr-dt-add-modal"
        wrapClassName="modern-dsr-dt-add-modal__wrap"
        title={<h3 className="modern-dsr-dt-add-modal__h-title">Create Project</h3>}
        closeIcon={(
          <span className="modern-dsr-dt-add-modal__close-icon" aria-hidden>
            <X size={20} strokeWidth={2} />
          </span>
        )}
        centered
        visible={isModalVisible}
        maskClosable={false}
        maskStyle={{ background: 'rgba(0, 0, 0, 0.5)' }}
        onCancel={handleCancel}
        destroyOnClose
        footer={(
          <div
            className="modern-dsr-dt-add-modal__foot"
            role="group"
            aria-label="Create project actions"
          >
            <CrceButton
              label="Cancel"
              variant="tertiary"
              size="medium"
              onClick={handleCancel}
            />
            <CrceButton
              label="OK"
              variant="primary"
              size="medium"
              onClick={handleOk}
            />
          </div>
        )}
      >
        <div>
          <Form
            form={projectForm}
            name="basic"
            layout="vertical"
            autoComplete="off"
          >
            <Row gutter={[24, 16]}>
              <Col lg={8}>
                <Form.Item
                  label="Project Name"
                  name="projectName"
                  required
                >
                  <Input
                    value={projectName}
                    onChange={(e) => setProjectName(e.target.value)}
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Form.Item
                  label="Project Number"
                  name="projectId"
                  required
                >
                  <Input
                    value={projectId}
                    onChange={(e) => setProjectId(e.target.value)}
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Form.Item
                  label="Client"
                  name="clientName"
                  required
                >
                  <Select
                    className="client-select"
                    dropdownClassName="modern-dropdown-popup"
                    popupClassName="modern-dropdown-popup"
                    placeholder="Select Client"
                    onChange={onChange}
                    onSearch={onSearch}
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <Divider style={{ margin: '8px 0', borderTop: '1px solid lightgrey' }} />
                        <Space
                          align="center"
                          style={{ padding: '0 8px 4px' }}
                        >
                          <Input
                            placeholder="Add Client"
                            value={newClient}
                            onChange={onAddNewClient}
                          />
                          <Typography.Link
                            onClick={addItem}
                            style={{ whiteSpace: 'nowrap', color: 'green' }}
                          >
                            <CheckOutlined />
                          </Typography.Link>
                          <Typography.Link
                            onClick={removeItem}
                            style={{ whiteSpace: 'nowrap', color: 'red' }}
                          >
                            <CloseOutlined />
                          </Typography.Link>
                        </Space>
                      </>
                    )}
                  >
                    {clientList &&
                      clientList.map((item, i) => (
                        <Option
                          key={i}
                          value={item && item.name}
                        >
                          {item && item.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Form.Item
                  label="Manager"
                  name="manager"
                  required
                >
                  <Input
                    value={manager}
                    onChange={(e) => setManager(e.target.value)}
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Form.Item
                  className="modern-create-project-date-field"
                  label="Start Date"
                  name="startDate"
                  required
                >
                  <DatePicker
                    className="modern-create-project-datepicker"
                    style={{ width: '100%' }}
                    getPopupContainer={getPopupContainerBody}
                    dropdownClassName="modern-dropdown-popup"
                    popupClassName="modern-dropdown-popup"
                    format="DD-MM-YYYY"
                    onChange={(date, dateString) => {
                      setStartDate(dateString);
                      if (endDate && dateString && endDate) {
                        const s = moment(dateString, 'DD-MM-YYYY', true);
                        const e = moment(endDate, 'DD-MM-YYYY', true);
                        if (s.isValid() && e.isValid() && s.isAfter(e, 'day')) {
                          notification.warning({
                            message: 'Start date should be previous than End date',
                          });
                        }
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Form.Item
                  className="modern-create-project-date-field"
                  label="End Date"
                  name="endDate"
                >
                  <DatePicker
                    className="modern-create-project-datepicker"
                    style={{ width: '100%' }}
                    getPopupContainer={getPopupContainerBody}
                    dropdownClassName="modern-dropdown-popup"
                    popupClassName="modern-dropdown-popup"
                    format="DD-MM-YYYY"
                    onChange={(date, dateString) => setEndDate(dateString)}
                    disabledDate={(current) => {
                      if (!startDate || !current) return false;
                      const s = moment(startDate, 'DD-MM-YYYY', true);
                      return s.isValid() && current < s.startOf('day');
                    }}
                  />
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Form.Item
                  label="Contract #"
                  name="contractId"
                  required
                >
                  <Input
                    value={contractId}
                    onChange={(e) => setContractId(e.target.value)}
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Form.Item
                  label="CRCE Ref #"
                  name="pihRefId"
                  required
                >
                  <Input
                    value={pihRefId}
                    onChange={(e) => setPihRefId(e.target.value)}
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Form.Item
                  label="Contractor"
                  name="contractor"
                  required
                >
                  <Input
                    value={contractor}
                    onChange={(e) => setContractor(e.target.value)}
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Form.Item
                  label="Location"
                  name="location"
                  required
                >
                  <Input
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Form.Item
                  label="Project Type"
                  name="projectType"
                  required
                >
                  <Select
                    className="client-select"
                    dropdownClassName="modern-dropdown-popup"
                    popupClassName="modern-dropdown-popup"
                    placeholder="Select project type"
                    value={projectType}
                    onChange={(value) => setProjectType(value)}
                  >
                    <Option value="Welding">Welding</Option>
                    <Option value="Coating">Coating</Option>
                    <Option value="Both">Both</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Form.Item
                  label="NDT Type"
                  name="ndtType"
                >
                  <Select
                    className="client-select ndt-type-select"
                    dropdownClassName="modern-dropdown-popup"
                    popupClassName="modern-dropdown-popup"
                    placeholder="Select NDT type"
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    value={projectNdtType}
                    onChange={(value) => setProjectNdtType(value)}
                    filterOption={(input, option) =>
                      String(option?.children ?? '')
                        .toLowerCase()
                        .includes(String(input).toLowerCase())
                    }
                  >
                    {NDT_PIPELINE_TYPE_OPTIONS.map((opt) => (
                      <Option key={opt.value} value={opt.value}>
                        {opt.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              {(projectType === 'Welding' || projectType === 'Both') && (
                <Col lg={8}>
                  <Form.Item
                    label="Max NDT reject % (client limit)"
                    name="ndtRejectMaxPercent"
                    tooltip="NDT rejects must stay at or below this percentage per client specification."
                  >
                    <InputNumber
                      min={0}
                      max={100}
                      step={0.1}
                      placeholder="e.g. 2"
                      style={{ width: '100%' }}
                      size="large"
                    />
                  </Form.Item>
                </Col>
              )}
              <Col lg={8}>
                <Form.Item
                  label="Final Client"
                  name="finalClient"
                >
                  <Select
                    className="client-select final-client-select"
                    dropdownClassName="modern-dropdown-popup"
                    popupClassName="modern-dropdown-popup"
                    placeholder="Select Final Client"
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    onChange={onChangeFinalClient}
                    filterOption={(input, option) =>
                      String(option?.children ?? '')
                        .toLowerCase()
                        .includes(String(input).toLowerCase())
                    }
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <Divider style={{ margin: '8px 0', borderTop: '1px solid lightgrey' }} />
                        <Space
                          align="center"
                          style={{ padding: '0 8px 4px' }}
                        >
                          <Input
                            placeholder="Add Final Client"
                            value={newFinalClient}
                            onChange={onAddNewFinalClient}
                          />
                          <Typography.Link
                            onClick={addFinalClientItem}
                            style={{ whiteSpace: 'nowrap', color: 'green' }}
                          >
                            <CheckOutlined />
                          </Typography.Link>
                          <Typography.Link
                            onClick={removeFinalClientItem}
                            style={{ whiteSpace: 'nowrap', color: 'red' }}
                          >
                            <CloseOutlined />
                          </Typography.Link>
                        </Space>
                      </>
                    )}
                  >
                    {clientList &&
                      clientList.map((item, i) => (
                        <Option
                          key={i}
                          value={item && item.name}
                        >
                          {item && item.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              {/* <Col lg={8}>
                <Form.Item
                  label="NDT Type"
                  name="ndtType"
                >
                  <ClientLikeSelect
                    placeholder="Select NDT type"
                    allowClear
                    value={projectNdtType}
                    onChange={(value) => setProjectNdtType(value)}
                  >
                    {NDT_PIPELINE_TYPE_OPTIONS.map((opt) => (
                      <Option key={opt.value} value={opt.value}>
                        {opt.label}
                      </Option>
                    ))}
                  </ClientLikeSelect>
                </Form.Item>
              </Col>
              {(projectType === 'Welding' || projectType === 'Both') && (
                <Col lg={8}>
                  <Form.Item
                    label="Max NDT reject % (client limit)"
                    name="ndtRejectMaxPercent"
                    tooltip="NDT rejects must stay at or below this percentage per client specification."
                  >
                    <InputNumber
                      min={0}
                      max={100}
                      step={0.1}
                      placeholder="e.g. 2"
                      style={{ width: '100%' }}
                      size="large"
                    />
                  </Form.Item>
                </Col>
              )}
              <Col lg={8}>
                <Form.Item
                  label="Final Client"
                  name="finalClient"
                >
                  <ClientLikeSelect
                    placeholder="Select Final Client"
                    allowClear
                    onChange={onChangeFinalClient}
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <Divider style={{ margin: '8px 0', borderTop: '1px solid lightgrey' }} />
                        <Space
                          align="center"
                          style={{ padding: '0 8px 4px' }}
                        >
                          <Input
                            placeholder="Add Final Client"
                            value={newFinalClient}
                            onChange={onAddNewFinalClient}
                          />
                          <Typography.Link
                            onClick={addFinalClientItem}
                            style={{ whiteSpace: 'nowrap', color: 'green' }}
                          >
                            <CheckOutlined />
                          </Typography.Link>
                          <Typography.Link
                            onClick={removeFinalClientItem}
                            style={{ whiteSpace: 'nowrap', color: 'red' }}
                          >
                            <CloseOutlined />
                          </Typography.Link>
                        </Space>
                      </>
                    )}
                  >
                    {clientList && clientList.map((item, i) =>
                      <Option key={i} value={item && item.name}>{item && item.name}</Option>)}
                  </Select>
                </Form.Item>
              </Col> */}
              <Col lg={24}>
                <div style={{ marginTop: '8px', marginBottom: '8px' }}>
                  <b>Technician Log Default Hours</b>
                </div>
              </Col>
              <Col lg={8}>
                <Form.Item
                  label="Day Shift"
                  name="dayShiftHour"
                  required
                >
                  <Input
                    value={dayShiftHour}
                    onChange={(e) => setDayShiftHour(e.target.value)}
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Form.Item
                  label="Night Shift"
                  name="nightShiftHour"
                  required
                >
                  <Input
                    value={nightShiftHour}
                    onChange={(e) => setNightShiftHour(e.target.value)}
                    size="large"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
    </>
  );
};

const mapDispatchToProps = {
  onAddClient: addClient,
};

export default connect(null, mapDispatchToProps)(CreateProject);
